import { useState, useCallback, useEffect } from 'react';
import { _getLeadSources, _addLeadSource } from 'controllers/leads/leads_controller';

export function useLeadSources(schoolId) {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSources = useCallback(async () => {
    if (!schoolId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await _getLeadSources(schoolId);
      const data = await res.json();
      setSources(data);
    } catch (err) {
      setSources([]);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [schoolId]);

  const addLeadSource = useCallback(
    async (name) => {
      if (!schoolId) return null;
      const response = await _addLeadSource(schoolId, { name });
      return response.json();
    },
    [schoolId]
  );

  useEffect(() => {
    fetchSources();
  }, [fetchSources]);

  return { sources, fetchSources, loading, error, addLeadSource };
}
